import moment from "moment";
import transFace from "../face";

interface info {
  name: string;
  avatar: string;
  position?: string;
  id?: string;
};

// 普通用户视角数据格式化
var formatGenerallist = (that: any, obj: any) => {
  let back: any = [];

  let data = obj.list;

  let presentersId = obj.presentersId;

  back = data.map((item: any) => {
    // 是否有回复
    let hasanswer = item.answer_id > 0;

    // 橙色显示
    let isOrange = presentersId.indexOf(item?.reply_user.user_id) != -1 ? 'orange' : '';

    let replyInfo = that.getSpecialUserInfo(item?.reply_user?.user_id, item?.reply_user?.user_nickname);

    let answerInfo: info;
    let aplyuserid = item?.reply_user?.user_id;
    let answername = "";

    //主持人
    if (that.presentersId.indexOf(aplyuserid) > -1) {
      answername = "主持人";
      answerInfo = that.getSpecialUserInfo(item?.reply_user?.user_id, item?.reply_user?.user_nickname);
    }
    //身份是嘉宾
    else {
      if (that.guestsId.indexOf(aplyuserid) > -1) {
        answerInfo = that.getSpecialUserInfo(item?.reply_user?.user_id, item?.reply_user?.user_nickname);
        answername = answerInfo?.position + '' + answerInfo?.name;
      } else {
        // answerInfo = that.getSpecialUserInfo(item?.answer_user?.user_id, item?.answer_user?.user_nickname);
        // answername = answerInfo.name;
        // 普通视角
        if (hasanswer) {
          answerInfo = that.getSpecialUserInfo(item?.answer_user?.user_id, item?.answer_user?.user_nickname);
          answername = answerInfo.name;
        } else {
          answerInfo = that.getSpecialUserInfo(item?.reply_user?.user_id, item?.reply_user?.user_nickname);
          answername = answerInfo.name;
        }

      }
    };

    // 我的提问
    let replyname = replyInfo.name;
    if (that.type == 1) {
      if (that.presentersId.indexOf(item?.reply_user?.user_id) != -1) {
        replyname = "主持人";
      };
      //身份是嘉宾
      if (that.guestsId.indexOf(item?.reply_user?.user_id) != -1) {
        replyname = replyInfo.position + '' + replyname;
        answername = answerInfo.position + '' + answername;
      };
    };

    // 有回答
    if (hasanswer) {
      //如果回答是嘉宾
      if (that.guestsId.indexOf(item?.answer_user?.user_id) != -1) {
        answername = answerInfo.position + '' + answername
      };
      //主持人
      if (that.presentersId.indexOf(item?.answer_user?.user_id) != -1) {
        answername = "主持人";
      };
    };

    // 发言时间及回复时间处理
    let answerpublishtime = moment(item.answer_publish_time).format('YYYY-MM-DD HH:mm') || "";
    let replypublishtime = moment(item.reply_publish_time).format('YYYY-MM-DD HH:mm') || "";

    // @*** 信息
    let replyAtInfo: info = that.getSpecialUserInfo(item?.reply_at_user?.user_id, item?.reply_at_user?.user_nickname);

    return {
      tabtype: that.type, // 切换类型
      infos: item,
      hasanswer: hasanswer,
      isOrange: isOrange,
      replyInfo: replyInfo,
      replyname: replyname,
      answerInfo: answerInfo,
      answername: answername,
      time: {
        answerpublishtime,
        replypublishtime
      },
      replyAtInfo: replyAtInfo,
      answer_text: transFace(item.answer_text),
      reply_text: transFace(item.reply_text)
    }
  });

  return back;
};


// 主持人嘉宾数据格式化(非浪客)
var formatSpeciallist = (that: any, obj: any) => {
  let back: any = [];

  let data = obj.list;

  let presentersId = obj.presentersId;

  back = data.map((item: any) => {
    // 是否有回复
    let hasanswer = item.answer_id > 0;

    // 是嘉宾主持人
    let isPresenter = that.presentersId.indexOf(item.reply_user.user_id) != -1
    let isGuester = !!that.guestsInfo[item.reply_user.user_id];

    // 橙色显示(主持人)
    let isOrange = presentersId.indexOf(item?.reply_user?.user_id) != -1 ? 'orange' : '';

    let replyInfo = that.getSpecialUserInfo(item?.reply_user?.user_id, item?.reply_user?.user_nickname);

    let answerInfo: info;
    let aplyuserid = item?.reply_user?.user_id;
    let answername = "";

    //主持人
    if (that.presentersId.indexOf(aplyuserid) > -1) {
      answername = "主持人";
      answerInfo = that.getSpecialUserInfo(item?.reply_user?.user_id, item?.reply_user?.user_nickname);
    }
    //身份是嘉宾
    else {
      if (that.guestsId.indexOf(aplyuserid) > -1) {
        answerInfo = that.getSpecialUserInfo(item?.reply_user?.user_id, item?.reply_user?.user_nickname);
        answername = answerInfo?.position + '' + answerInfo?.name;
      } else {
        answerInfo = that.getSpecialUserInfo(item?.answer_user?.user_id, item?.answer_user?.user_nickname);
        answername = answerInfo?.name;
      }
    };


    // 主持人嘉宾发帖
    // if (that.isSpecialStatus){
    //   if (that.presentersId.indexOf(aplyuserid) > -1) {
    //     answername = "主持人";
    //     answerInfo = that.getSpecialUserInfo(item?.reply_user?.user_id, item?.reply_user?.user_nickname);
    //   }

    //   if (that.guestsId.indexOf(aplyuserid) > -1) {
    //     answerInfo = that.getSpecialUserInfo(item?.reply_user?.user_id, item?.reply_user?.user_nickname);
    //     answername = answerInfo?.position + '' + answerInfo?.name;
    //   }
    // };

    // // 普通用户发帖
    // if (!that.isSpecialStatus){
    //   answerInfo = that.getSpecialUserInfo(item?.answer_user?.user_id, item?.answer_user?.user_nickname);
    //   answername = answerInfo?.name;
    // };

    // 我的提问
    let replyname = replyInfo?.name;

    if (that.presentersId.indexOf(item?.reply_user?.user_id) != -1) {
      replyname = "主持人";
    };

    //身份是嘉宾
    if (that.guestsId.indexOf(item?.reply_user?.user_id) != -1) {
      replyname = replyInfo?.position + '' + replyname;
    };


    // 有回答
    if (hasanswer) {
      //如果回答是嘉宾
      if (that.guestsId.indexOf(item?.answer_user?.user_id) != -1) {
        answername = answerInfo?.position + '' + answername
      };
      //主持人
      if (that.presentersId.indexOf(item?.answer_user?.user_id) != -1) {
        answername = "主持人";
      };
    };

    // 发言时间及回复时间处理
    let answerpublishtime = moment(item?.answer_publish_time).format('YYYY-MM-DD HH:mm') || "";
    let replypublishtime = moment(item?.reply_publish_time).format('YYYY-MM-DD HH:mm') || "";

    // @*** 信息
    let replyAtInfo: info = that.getSpecialUserInfo(item?.reply_at_user?.user_id, item?.reply_at_user?.user_nickname);

    // 嘉宾自己发言可以删除 非回顾
    let showDelete = item?.answer_user?.user_id === that.uid && that.status != 3;

    // 是嘉宾  非主持人 非回顾
    let isGuest = that.isSpecialStatus && that.presentersId.indexOf(item.reply_user.user_id) == -1 && !that.guestsInfo[item.reply_user.user_id] && that.status != 3;

    // 忽略和取消忽略
    let showIgnore = isGuest && that.type != 5; // 5回收站
    let cancelIgnore = isGuest && that.type == 5; // 5回收站

    // 精选和取消精选
    let isCareSelfVal = item?.is_careself_val; // 是否精选
    let showCareSelfBtn = !isPresenter && !isGuester && that.type != 5 && that.status != 3;;// 是否展示精选按钮

    return {
      tabtype: that.type, // 切换类型
      infos: item,
      hasanswer: hasanswer,
      isOrange: isOrange,
      replyInfo: replyInfo,
      replyname: replyname,
      answerInfo: answerInfo,
      answername: answername,
      time: {
        answerpublishtime,
        replypublishtime
      },
      replyAtInfo: replyAtInfo,
      answer_text: transFace(item.answer_text),
      reply_text: transFace(item.reply_text),
      showDelete: showDelete, //是否有可删除权限
      showIgnore: showIgnore,  //是否显示忽略
      cancelIgnore: cancelIgnore,//显示取消忽略
      isCareSelfVal: isCareSelfVal,  // 是否精选
      showCareSelfBtn: showCareSelfBtn
    }
  });

  return back;
};

// 嘉宾信息 东财通行证转浪客通行证
var getLangkeNickname = function(list:Array<any>,pfuid:string|number){
  if(!list?.length || !pfuid) return {};
  let back = list.filter(v=>v.emuid == pfuid);
  if(!back.length) return {};
  return back[0];
};


// 主持人数据格式化(浪客)
var formatPresenterlistLK = (that: any, obj: any) => {
  let back: any = [];

  let data = obj.list;

  let presentersId = obj.presentersId;

  back = data.map((item: any) => {
    // 是否有回复
    // let hasanswer = item.answer_id > 0;
    let hasanswer = !!item.answer_user;

    // 是嘉宾主持人
    let isPresenter = that.presentersId.indexOf(item?.reply_user?.user_id) != -1
    let isGuester = !!that.guestsInfo[item?.reply_user?.user_id];

    // 橙色显示(主持人)
    let isOrange = presentersId.indexOf(item?.reply_user?.user_id) != -1 ? 'orange' : '';

    let replyInfo = that.getSpecialUserInfo(item?.reply_user?.user_id, item?.reply_user?.user_nickname);

    let answerInfo: info;
    let aplyuserid = item?.reply_user?.user_id;
    let answername = "";

    //主持人
    if (that.presentersId.indexOf(aplyuserid) > -1) {
      answername = "主持人";
      answerInfo = that.getSpecialUserInfo(item?.reply_user?.user_id, item?.reply_user?.user_nickname);
    }
    //身份是嘉宾
    else {
      if (that.guestsId.indexOf(aplyuserid) > -1) {
        answerInfo = that.getSpecialUserInfo(item?.reply_user?.user_id, item?.reply_user?.user_nickname);
        answername = answerInfo?.position + '' + answerInfo?.name;
      } else {
        answerInfo = that.getSpecialUserInfo(item?.answer_user?.user_id, item?.answer_user?.user_nickname);
        answername = answerInfo?.name;
      }
    };

    // 我的提问
    let replyname = replyInfo?.name;

    if (that.presentersId.indexOf(item?.reply_user?.user_id) != -1) {
      replyname = "主持人";
    };

    //身份是嘉宾
    if (that.guestsId.indexOf(item?.reply_user?.user_id) != -1) {
      replyname = replyInfo?.position + '' + replyname;
    };


    // 有回答
    if (hasanswer) {
      //如果回答是嘉宾
      if (that.guestsId.indexOf(item?.answer_user?.user_id) != -1) {
        answername = answerInfo?.position + '' + answername
      };
      //主持人
      if (that.presentersId.indexOf(item?.answer_user?.user_id) != -1) {
        answername = "主持人";
      };
    };

    // 发言时间及回复时间处理
    let answerpublishtime = moment(item?.answer_publish_time).format('YYYY-MM-DD HH:mm') || "";
    let replypublishtime = moment(item?.reply_publish_time).format('YYYY-MM-DD HH:mm') || "";

    // @*** 信息
    let replyAtInfo: info = that.getSpecialUserInfo(item?.reply_at_user?.user_id, item?.reply_at_user?.user_nickname);

    // 嘉宾自己发言可以删除 非回顾
    let showDelete = item?.answer_user?.user_id === that.uid && that.status != 3;

    // 是嘉宾  非主持人 非回顾
    let isGuest = that.isSpecialStatus && that.presentersId.indexOf(item.reply_user.user_id) == -1 && !that.guestsInfo[item.reply_user.user_id] && that.status != 3;

    // 忽略和取消忽略
    let showIgnore = isGuest && that.type != 21; // 21回收站
    let cancelIgnore = isGuest && that.type == 21; // 21回收站

    // 精选和取消精选
    let isCareSelfVal = item?.is_careself_val; // 是否精选
    let showCareSelfBtn = !isPresenter && !isGuester && that.type != 21 && that.status != 3;;// 是否展示精选按钮

    // 派发按钮显示
    let showPaifaBtn = item?.paifa_user == null && !isPresenter && !isGuester && that.status != 3;;
    let showPaifaLab = item?.paifa_user !== null && !isPresenter && !isGuester;

    let langkeGuestInfo:any = getLangkeNickname(that.guests,item?.paifa_user?.user_id);

    return {
      tabtype: that.type, // 切换类型
      infos: item,
      hasanswer: hasanswer,
      isOrange: isOrange,
      replyInfo: replyInfo,
      replyname: replyname,
      answerInfo: answerInfo,
      answername: answername,
      time: {
        answerpublishtime,
        replypublishtime
      },
      replyAtInfo: replyAtInfo,
      answer_text: transFace(item.answer_text),
      reply_text: transFace(item.reply_text),
      showDelete: showDelete, //是否有可删除权限
      showIgnore: showIgnore,  //是否显示忽略
      cancelIgnore: cancelIgnore,//显示取消忽略
      isCareSelfVal: isCareSelfVal,  // 是否精选
      showCareSelfBtn: showCareSelfBtn,
      showPaifaBtn:showPaifaBtn,
      showPaifaLab:showPaifaLab,
      hasPaifaname:langkeGuestInfo?.target_nickname || langkeGuestInfo?.nickname || "",
      hasPaifaPosition:langkeGuestInfo.position || ""
    }
  });

  return back;
};


// 嘉宾数据格式化(浪客)
var formatGuestlistLK = (that: any, obj: any) => {
  let back: any = [];

  let data = obj.list;

  let presentersId = obj.presentersId;

  back = data.map((item: any) => {
    // 是否有回复
    // let hasanswer = item.answer_id > 0;
    let hasanswer = !!item.answer_user;

    // 是嘉宾主持人
    let isPresenter = that.presentersId.indexOf(item.reply_user.user_id) != -1
    let isGuester = !!that.guestsInfo[item.reply_user.user_id];

    // 橙色显示(主持人)
    let isOrange = presentersId.indexOf(item?.reply_user?.user_id) != -1 ? 'orange' : '';

    let replyInfo = that.getSpecialUserInfo(item?.reply_user?.user_id, item?.reply_user?.user_nickname);

    let answerInfo: info;
    let aplyuserid = item?.reply_user?.user_id;
    let answername = "";

    //主持人
    if (that.presentersId.indexOf(aplyuserid) > -1) {
      answername = "主持人";
      answerInfo = that.getSpecialUserInfo(item?.reply_user?.user_id, item?.reply_user?.user_nickname);
    }
    //身份是嘉宾
    else {
      if (that.guestsId.indexOf(aplyuserid) > -1) {
        answerInfo = that.getSpecialUserInfo(item?.reply_user?.user_id, item?.reply_user?.user_nickname);
        answername = answerInfo?.position + '' + answerInfo?.name;
      } else {
        answerInfo = that.getSpecialUserInfo(item?.answer_user?.user_id, item?.answer_user?.user_nickname);
        answername = answerInfo?.name;
      }
    };

    // 我的提问
    let replyname = replyInfo?.name;

    if (that.presentersId.indexOf(item?.reply_user?.user_id) != -1) {
      replyname = "主持人";
    };

    //身份是嘉宾
    if (that.guestsId.indexOf(item?.reply_user?.user_id) != -1) {
      replyname = replyInfo?.position + '' + replyname;
    };


    // 有回答
    if (hasanswer) {
      //如果回答是嘉宾
      if (that.guestsId.indexOf(item?.answer_user?.user_id) != -1) {
        answername = answerInfo?.position + '' + answername
      };
      //主持人
      if (that.presentersId.indexOf(item?.answer_user?.user_id) != -1) {
        answername = "主持人";
      };
    };

    // 发言时间及回复时间处理
    let answerpublishtime = moment(item?.answer_publish_time).format('YYYY-MM-DD HH:mm') || "";
    let replypublishtime = moment(item?.reply_publish_time).format('YYYY-MM-DD HH:mm') || "";

    // @*** 信息
    let replyAtInfo: info = that.getSpecialUserInfo(item?.reply_at_user?.user_id, item?.reply_at_user?.user_nickname);

    // 嘉宾自己发言可以删除 非回顾
    let showDelete = item?.answer_user?.user_id === that.uid && that.status != 3;

    // 是嘉宾  非主持人 非回顾
    let isGuest = that.isSpecialStatus && that.presentersId.indexOf(item.reply_user.user_id) == -1 && !that.guestsInfo[item.reply_user.user_id] && that.status != 3;

    // 忽略和取消忽略
    let showIgnore = isGuest && that.type != 34; // 34回收站
    let cancelIgnore = isGuest && that.type == 34; // 34回收站

    // 精选和取消精选
    let isCareSelfVal = item?.is_careself_val; // 是否精选
    let showCareSelfBtn = !isPresenter && !isGuester && that.type != 21 && that.status != 3;;// 是否展示精选按钮

    let langkeGuestInfo:any = getLangkeNickname(that.guests,item?.paifa_user?.user_id);
    let showPaifaLab = item?.paifa_user !== null && !isPresenter && !isGuester;

    return {
      tabtype: that.type, // 切换类型
      infos: item,
      hasanswer: hasanswer,
      isOrange: isOrange,
      replyInfo: replyInfo,
      replyname: replyname,
      answerInfo: answerInfo,
      answername: answername,
      time: {
        answerpublishtime,
        replypublishtime
      },
      replyAtInfo: replyAtInfo,
      answer_text: transFace(item.answer_text),
      reply_text: transFace(item.reply_text),
      showDelete: showDelete, //是否有可删除权限
      showIgnore: showIgnore,  //是否显示忽略
      cancelIgnore: cancelIgnore,//显示取消忽略
      isCareSelfVal: isCareSelfVal,  // 是否精选
      showCareSelfBtn: showCareSelfBtn,
      hasPaifaname:langkeGuestInfo?.target_nickname || langkeGuestInfo?.nickname,
      showPaifaLab:showPaifaLab
    }
  });

  return back;
};



export { formatGenerallist, formatSpeciallist, formatPresenterlistLK,formatGuestlistLK }